import { Skeleton } from "@/components/ui/skeleton";
import { PageContainer } from "@/components/ui/page-container";

export function DisciplineDetailSkeleton() {
  return (
    <PageContainer className="mt-2.5">
      <div className="space-y-4 p-6 lg:space-y-[34px] lg:px-10 lg:py-8">
        {/* Title */}
        <Skeleton className="h-8 w-48 lg:h-9 lg:w-56" />

        <div className="space-y-4 md:space-y-8">
          {/* Name field */}
          <div className="flex flex-col gap-2">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-6 w-40 md:h-7 lg:h-8 lg:w-48" />
          </div>

          {/* Abbreviation and Color fields grid */}
          <div className="grid grid-cols-1 gap-4 md:gap-8 xl:grid-cols-2">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-6 w-20 md:h-7 lg:h-8" />
            </div>

            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-6 w-[248px] md:h-7 md:w-[296px] lg:h-8 xl:w-[448px]" />
            </div>
          </div>

          {/* Description field */}
          <div className="flex flex-col gap-2">
            <Skeleton className="h-5 w-40" />
            <Skeleton className="h-24 w-full md:h-28 lg:h-32" />
          </div>
        </div>
      </div>
    </PageContainer>
  );
}
